export default function idToUrl(url: string, id: string | number): string {
  return url.replace(/[\d]{1,}$/, `${id}`);
}
